module.exports = __webpack_public_path__ + "f4e7aeb413477619586ab5c58d1d4fa1.ttf";